import React from "react";
import { Grid, Paper, Typography, Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { ResizableTable } from "../../../components/resizableTable/ResizableTable";

const WinLossAnalysisPaper = ({
  classes,
  paperTitle,
  createWinLossTableColumns,
  handleChangeLocation,
  currencySymbol,
}) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Typography variant="h5" className={classes.title}>
            Win-Loss analysis: Month of XXX
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>

        <Grid container spacing={2}>
          {/* Won Opportunities Table */}
          <Grid item xs={12} md={6}>
            <ResizableTable
              columns={createWinLossTableColumns(currencySymbol)}
              rows={[
                {
                  customerName: "Customer A",
                  acvInMillions: 1.2,
                  competition: "Competitor X",
                  keyLearnings: "Strong technical fit",
                  label: "Customer A",
                },
                {
                  customerName: "Customer B",
                  acvInMillions: 0.8,
                  competition: "None",
                  keyLearnings: "Existing relationship",
                  label: "Customer B",
                },
              ]}
              getCellValue={(row, field) => row[field] || ""}
              rowKey="label"
              heading="Won Opportunities"
              hideSubHeaderRow={true}
              maxWidth="100%"
              onRowClick={(row) =>
                handleChangeLocation("drilldownOnGraph", row, "winLossWon")
              }
            />
          </Grid>

          {/* Lost Opportunities Table */}
          <Grid item xs={12} md={6}>
            <ResizableTable
              columns={createWinLossTableColumns(currencySymbol)}
              rows={[
                {
                  customerName: "Customer C",
                  acvInMillions: 1.5,
                  competition: "Competitor Y",
                  keyLearnings: "Price sensitivity",
                  label: "Customer C",
                },
                {
                  customerName: "Customer D",
                  acvInMillions: 0.9,
                  competition: "Competitor Z",
                  keyLearnings: "Feature gaps",
                  label: "Customer D",
                },
              ]}
              getCellValue={(row, field) => row[field] || ""}
              rowKey="label"
              heading="Lost Opportunities"
              hideSubHeaderRow={true}
              maxWidth="100%"
              onRowClick={(row) =>
                handleChangeLocation("drilldownOnGraph", row, "winLossLost")
              }
            />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default WinLossAnalysisPaper;
